import React from 'react';
import { Card, Table, Badge, Row, Col, Button } from 'react-bootstrap';
import { FaBatteryFull, FaArrowRight, FaEdit } from 'react-icons/fa';

// Targeta de resum de la bateria virtual (origen, destins, % repartiment); usada a OfertaDetail i ContratoDetail.
const VirtualBatteryCard = ({ bateriaVirtual, onEdit }) => {
    console.log("VirtualBatteryCard prop:", bateriaVirtual);
    if (!bateriaVirtual) return null;

    const { destinos, cups_origen_name } = bateriaVirtual;

    // if (!crea_bat_auto && (!destinos || destinos.length === 0)) {
    //    return null;
    // }

    return (
        <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden">
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaBatteryFull className="me-2 text-success" />
                    Batería Virtual
                </div>
                {onEdit && (
                    <Button
                        variant="link"
                        className="p-0 text-decoration-none"
                        onClick={onEdit}
                        style={{ color: 'inherit' }}
                    >
                        <FaEdit />
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                <Row className="g-4 mb-3">
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaBatteryFull className="detail-card-icon text-success" />
                            <div>
                                <label className="detail-card-label">Estado</label>
                                <div><Badge bg="success">Activa</Badge></div>
                            </div>
                        </div>
                    </Col>

                    {(bateriaVirtual.periodos_aplicacion || bateriaVirtual.periodos_aplicacion_label) && (
                        <Col md={6}>
                            <div className="d-flex align-items-center">
                                <FaBatteryFull className="detail-card-icon" style={{ opacity: 0 }} /> {/* Spacer */}
                                <div>
                                    <label className="detail-card-label">Periodo Aplicación</label>
                                    <p className="detail-card-value">{bateriaVirtual.periodos_aplicacion_label || bateriaVirtual.periodos_aplicacion}</p>
                                </div>
                            </div>
                        </Col>
                    )}

                    {cups_origen_name && (
                        <Col md={12}>
                            <div className="d-flex align-items-center">
                                <FaArrowRight className="detail-card-icon" />
                                <div>
                                    <label className="detail-card-label">CUPS de origen</label>
                                    <p className="detail-card-value text-primary text-truncate" title={cups_origen_name}>
                                        {cups_origen_name}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>

                {destinos && destinos.length > 0 ? (
                    <div className="destinos-section">
                        <h6 className="text-muted mb-3 border-bottom pb-2">Destinos y reparto</h6>
                        <Table responsive bordered hover size="sm" className="align-middle">
                            <thead className="bg-light">
                                <tr>
                                    <th>CUPS destino</th>
                                    <th className="text-center" style={{ width: '100px' }}>% reparto</th>
                                </tr>
                            </thead>
                            <tbody>
                                {destinos.map((dest, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <FaArrowRight className="text-muted me-2" size={12} />
                                                <span className="font-monospace" title={dest.cupsDestinoName || dest.cupsDestino}>
                                                    {dest.cupsDestinoName || dest.cupsDestino}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <Badge bg="info" className="fs-6">
                                                {dest.porcentaje}%
                                            </Badge>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div className="alert alert-light border text-center text-muted small p-2">
                        Sin destinos configurados.
                        <br />
                        Excedentes al monedero.
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default VirtualBatteryCard;
